import React from "react";
// Components
import VerifySession from "../../config/verifySession";
import Projects from "../../components/projects";

const ProjectsView = () => (
  <>
    {VerifySession()}
    <Projects />
  </>
);

export default ProjectsView;
